import React, { Component } from 'react';
import {API} from 'aws-amplify';

class Ec2PaUserInputPanel extends Component {

  state = {
    inputActionTaken: '',
    inputComment: '',
    inputStatus: '',
    inputTemplate: '',
    errMessage: ''
  };

  componentDidMount() {

  };

  render() {

    const {username} = this.props;

    const {inputActionTaken, inputComment, inputStatus, inputTemplate, errMessage} = this.state;

    return (
      <form className="Ec2PaUserInputPanelPage" action="">
        <div>User: {username}</div>
        <div>Action Taken: <input value={inputActionTaken} type="text" name="inputActionTaken" onChange={this.handleInput}/></div>
        <div>Comments: <textarea value={inputComment} rows="2" cols="25" name="inputComment" onChange={this.handleInput}/></div>
        <div>{'Status: '}
          <input type="radio" name="inputStatus" value="Fixed" checked={inputStatus === 'Fixed'} onChange={this.handleInput}/>{' Fixed '}
          <input type="radio" name="inputStatus" value="Not Fixed" checked={inputStatus === 'Not Fixed'} onChange={this.handleInput}/> Not Fixed
        </div>
        <div>{'Template: '}
          <select name="inputTemplate" value={inputTemplate} onChange={this.handleInput}>
            <option value=""></option>
            <option value="PostponedUntilNextUpdate">Postponed until next update</option>
          </select>
        </div>
        <button onClick={this.updateCommandLog}>Submit</button>
        {errMessage && <p>{errMessage}</p>}
      </form>
    );

  };

    handleInput = e => {
      this.setState({[e.target.name]: e.target.value});
      if (e.target.name === 'inputTemplate') this.applyTemplate(e.target.value);
    }

    applyTemplate = template => {

      const templates = {
        PostponedUntilNextUpdate: {
          inputActionTaken: 'None',
          inputComment: 'Postponed until next maintenance window.',
          inputStatus: 'Not Fixed'
        }
      };

      this.setState({...templates[template], inputTemplate: ''});

    }

    updateCommandLog = () => {

      if (!this.props.InstanceIds) {
        this.setState({errMessage: 'Instance ID is not defined.'});
      } else if (!this.props.RequestedDateTime) {
        this.setState({errMessage: 'RequestedDateTime is not defined.'});
      } else if (!this.props.username) {
        this.setState({errMessage: 'User is not defined.'});
      } else if (!this.state.inputActionTaken) {
        this.setState({errMessage: 'Action taken cannot be blank.'});
      } else if (!this.state.inputComment) {
        this.setState({errMessage: 'Comments cannot be blank.'});
      } else if (!this.state.inputStatus) {
        this.setState({errMessage: 'Status cannot be blank.'});
      } else {

        const queryStringParameters = {
          instanceid: this.props.InstanceIds,
          requesteddatetime: this.props.RequestedDateTime,
          rby: this.props.username,
          rcomment: this.state.inputComment,
          ractiontaken: this.state.inputActionTaken,
          rstatus: this.state.inputStatus,
          action: 'update'
        };

        API.get('WBU', '/ec2commands', {queryStringParameters})
        .then(res => {
          this.setState({errMessage: 'Acknowledgement has been submitted'});
        })
        .catch(err => {
          console.log(err);
        });
      }

    }

};

export default Ec2PaUserInputPanel;


// WEBPACK FOOTER //
// ./src/components/content/ec2PatchErrors/ec2PaContent/ec2PaRequiredAttention/ec2PaUserInputPanel/ec2PaUserInputPanel.js